'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var IP_COUNTRY_QUERY = 'ip-country:query';
var USER_COUNTRY_QUERY = 'user-country:query';
var USER_COUNTRY_UPDATED = 'user-country:event';
var USER_JURISDICTION_QUERY = 'user-jurisdiction:query';
var USER_JURISDICTION_UPDATED = 'user-jurisdiction:event';
var COUNTRY_JURISDICTION_QUERY = 'country-jurisdiction:query';

exports.COUNTRY_JURISDICTION_QUERY = COUNTRY_JURISDICTION_QUERY;
exports.IP_COUNTRY_QUERY = IP_COUNTRY_QUERY;
exports.USER_COUNTRY_QUERY = USER_COUNTRY_QUERY;
exports.USER_COUNTRY_UPDATED = USER_COUNTRY_UPDATED;
exports.USER_JURISDICTION_QUERY = USER_JURISDICTION_QUERY;
exports.USER_JURISDICTION_UPDATED = USER_JURISDICTION_UPDATED;
